import { render } from "./ResitBatal.vue?vue&type=template&id=4d2c5ef6"
import script from "./ResitBatal.vue?vue&type=script&lang=js"
export * from "./ResitBatal.vue?vue&type=script&lang=js"

import "./ResitBatal.vue?vue&type=style&index=0&id=4d2c5ef6&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__